import { shopPrefix } from '../../config';
import { http } from '../axios';

const FETCH_NEXT_AVAILABLE_DATES_URL = `${shopPrefix}/v1/products/availabilities`;

interface AvailableDate {
    available: boolean;
    nextAvailableDate: string;
}

interface ProductAvailabilitiesResponse {
    productAvailabilities: { [productId: string]: AvailableDate };
}

export const fetchNextAvailableDates = (productId: string) => {
    return http
        .post<ProductAvailabilitiesResponse>(FETCH_NEXT_AVAILABLE_DATES_URL, {
            productIds: [productId]
        })
        .then(response => response.data.productAvailabilities[productId]);
};
